import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RecordingsCommunityApproveAutomaticallyRequest, RecordingsCommunityResponse } from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable()
export class RecordingsCommunitiesService {
  private readonly url = `${environment.bffUrl}/recordings-communities`;
  constructor(private http: HttpClient) {}
  getAll(): Observable<RecordingsCommunityResponse[]> {
    return this.http.get<RecordingsCommunityResponse[]>(this.url);
  }
  getOne(id: string): Observable<RecordingsCommunityResponse> {
    return this.http.get<RecordingsCommunityResponse>(`${this.url}/${id}`);
  }
  toggleAutomaticApproval(id: string, req: RecordingsCommunityApproveAutomaticallyRequest): Observable<RecordingsCommunityResponse> {
    return this.http.post<RecordingsCommunityResponse>(`${this.url}/${id}/approve-recordings-automatically`, req);
  }
}
